// La capa escrita en la firma del header (pedido del fundador 2026-09-14,
// maqueta "La capa en el header"): "MiPAE.— interno". El punto y el trazo
// siguen siendo la firma de marca; detrás, en letra chica y del color del
// módulo que define a esa capa, se escribe la capa del perfil. Dominio puro:
// qué palabra y qué color le tocan a un perfil. Catálogo cerrado, jamás
// texto libre; con un perfil sin capa clara (sin rol) no se escribe nada,
// que es mejor que adivinar. Desde el 2026-10-04 hay tres roles
// (lib/roles.js): postgrado y docencia escriben "enfermero/a".
import { esCapaEjercicio } from './perfil';
import { esTens } from './tens';
import { getSegmento } from './segmento';
import { nombreMundo } from './mundos';

// Color = el módulo que define a la capa (tokens `text-module-*`, jamás hex):
// estudiante → PAE Rápido, interno → Prepara tu internado, ejercicio → MiPAE
// en turno (prepara-turno es su token), TENS → Escalas, jefatura → Bitácora
// (el rosado, distinto de todos los demás).
// "interno/a" y "enfermero/a" con la barra (A40, respuesta del fundador
// 2026-10-04): la firma nombra a la persona, y así lo hace el resto de la app
// (Mi perfil, el selector de rol). Estudiante, TENS y jefatura no cambian.
// El `id` sigue sin barra: es catálogo, no texto visible.
//
// `simbolo` (2026-10-16, pedido del fundador: "tens un termómetro, enfermero
// una jeringa, estudiante un lápiz"; eligió "Solo el símbolo" entre tres
// maquetas, docs/pitch/preview-simbolo-header/): en pantalla el dibujo
// REEMPLAZA a la palabra, que se queda para el lector de pantalla. La interna
// lleva el lápiz del estudiante porque el internado es una etapa del
// estudiante, no otro rol (lib/roles.js); la distingue su color. Jefatura no
// tiene símbolo y sigue escribiendo su palabra. Es un id de catálogo: el
// dibujo lo pone LockupHeader.
//
// `modo` (mismo día, Sebastián eligió "MiPAE Enfermero" entre tres maquetas,
// docs/pitch/preview-modo-header/): cada tanto la firma y el símbolo se hacen
// a un lado y el header dice el nombre del modo, "MiPAE Enfermero". Sale de
// `nombreMundo` (lib/mundos.js), el mismo nombre de Mi perfil, sin el "MiPAE"
// que ya escribe el wordmark. La interna está en MiPAE Estudiante, así que su
// modo es "Estudiante" aunque su capa diga "interno/a".
const modoDe = (mundo) => (nombreMundo(mundo) || '').replace(/^MiPAE\s+/, '') || null;

export const CAPAS_HEADER = Object.freeze({
  estudiante: { id: 'estudiante', palabra: 'estudiante',  color: 'text-module-pae-rapido',        simbolo: 'lapiz',      modo: modoDe('estudiante') },
  interno:    { id: 'interno',    palabra: 'interno/a',   color: 'text-module-prepara-internado', simbolo: 'lapiz',      modo: modoDe('estudiante') },
  enfermero:  { id: 'enfermero',  palabra: 'enfermero/a', color: 'text-module-prepara-turno',     simbolo: 'jeringa',    modo: modoDe('enfermero') },
  tens:       { id: 'tens',       palabra: 'tens',        color: 'text-module-escalas',           simbolo: 'termometro', modo: modoDe('tens') },
  jefatura:   { id: 'jefatura',   palabra: 'jefatura',    color: 'text-module-bitacora',          simbolo: null,         modo: null },
});

/**
 * La capa que la firma escribe para este perfil, o null si no hay una clara.
 * Jefatura es un PERMISO sobre el rol (`profiles.ve_jefatura`, concedido a
 * mano), no un rol: cuando está, es lo que la persona ES en su unidad y gana.
 * Admin/owner NO cuentan como jefatura (el fundador es enfermero).
 * @param {object|null} profile
 * @returns {{id:string, palabra:string, color:string, simbolo:string|null, modo:string|null}|null}
 */
export function capaDelPerfil(profile) {
  if (!profile) return null;
  if (profile.ve_jefatura === true) return CAPAS_HEADER.jefatura;
  if (esTens(profile)) return CAPAS_HEADER.tens;
  if (esCapaEjercicio(profile)) return CAPAS_HEADER.enfermero;
  const seg = getSegmento(profile);
  if (seg === 'internado') return CAPAS_HEADER.interno;
  if (seg === 'estudiante') return CAPAS_HEADER.estudiante;
  return null;
}
